import { Button, Col, ConfigProvider, Layout, Pagination, Row } from 'antd';
import { RouteComponentProps } from 'react-router';
import { Content } from 'antd/lib/layout/layout';
import OAMSider from "../oam-sider";
import React from "react";
import zhCN from 'antd/lib/locale/zh_CN';

import MenuPreview from './menu-preview';

export const menuList = [
    {
        id: 1,
        name: "数据可视化",
        directory: [
                        {id:1, name:"数据可视化概述" , modules:[{id:1,name:'可视化概念与简史'},{id:2,name:'可视化的基本原理'}]},
                        {id:2, name: "结构数据的可视化图形" , modules:[{id:3,name:'基本数据图形'},{id:4,name:'描述分布图形'},{id:5,name:'多维数据图形'}]},
                        {id:3, name:"非结构化数据可视化" , modules:[{id:6,name:'时间数据可视化'},{id:7,name:'空间数据可视化'},{id:8,name:'网络数据可视化'},{id:9,name:'文本数据可视化'}]},
                        {id:4, name:"基于算法模型的可视化分析" , modules:[{id:10,name:'线性回归模型可视化分析'},{id:11,name:'决策树算法可视化分析'}]}
                    ],
        createTime: "2021-9-18",
        modifyTime: "2021-10-20",
        user: "gaoyan",
        status: 1,
    },
    {
        id: 2,
        name: "数据科学导引",
        directory: [
            {id:1, name:"数据科学介绍" , modules:[{id:12,name:'数据科学概述'},{id:13,name:'数据科学的基本内容'},{id:14,name:'数据科学的行业应用'}]},
            {id:2, name: "数据预处理" , modules:[{id:15,name:'数据诊断与探索'},{id:16,name:'缺失值处理'},{id:17,name:'离群值处理'},{id: 18,name: "特征编码"}]},
            {id:3, name:"回归" , modules:[{id:19,name:'简单线性回归'},{id:20,name:'岭回归和LASSO'}]},
            {id:4, name:"分类" , modules:[{id:21,name:'分类问题介绍'},{id:22,name:'逻辑回归'},{id:23,name:'K近邻'},{id:24,name:'决策树'},{id:25,name:'朴素贝叶斯'}]},
            {id:5, name:"集成方法" , modules:[{id:26,name:'集成方法介绍'},{id:27,name:'随机森林'},{id:28,name:'AdaBoost'}]},
            {id:6, name:"聚类" , modules:[{id:29,name:'聚类问题介绍'},{id:30,name:'K-Means聚类'},{id:31,name:'层次聚类'}]},
            {id:7, name:"降维" , modules:[{id:32,name:'降维介绍'},{id:33,name:'主成分分析'}]}
        ],
        createTime: "2021-7-18",
        modifyTime: "2021-9-20",
        user: "jiatian",
        status: 1,
    },
    {
        id: 3,
        name: "Python语言基础",
        directory: [
            {id:1, name:"数据可视化概述" , modules:[{id:101,name:'可视化概念与简史'},{id:102,name:'可视化的基本原理'}]},
            {id:2, name: "结构数据的可视化图形" , modules:[{id:3,name:'基本数据图形'},{id:4,name:'描述分布图形'},{id:5,name:'多维数据图形'}]},
            {id:3, name:"非结构化数据可视化" , modules:[{id:6,name:'时间数据可视化'},{id:7,name:'空间数据可视化'},{id:8,name:'网络数据可视化'},{id:9,name:'文本数据可视化'}]},
            {id:4, name:"基于算法模型的可视化分析" , modules:[{id:10,name:'线性回归模型可视化分析'},{id:11,name:'决策树算法可视化分析'}]}
        ],
        createTime: "2021-9-18",
        modifyTime: "2021-9-20",
        user: "jiatian",
        status: 1,
    },
    {
        id: 4,
        name: "深度学习",
        directory: [
            {id:1, name:"数据可视化概述" , modules:[{id:1,name:'可视化概念与简史'},{id:2,name:'可视化的基本原理'}]},
            {id:2, name: "结构数据的可视化图形" , modules:[{id:3,name:'基本数据图形'},{id:4,name:'描述分布图形'},{id:5,name:'多维数据图形'}]},
            {id:3, name:"非结构化数据可视化" , modules:[{id:6,name:'时间数据可视化'},{id:7,name:'空间数据可视化'},{id:8,name:'网络数据可视化'},{id:9,name:'文本数据可视化'}]},
            {id:4, name:"基于算法模型的可视化分析" , modules:[{id:10,name:'线性回归模型可视化分析'},{id:11,name:'决策树算法可视化分析'}]}
        ],
        createTime: "2021-9-18",
        modifyTime: "2021-9-20",
        user: "jianglong",
        status: 1,
    }
]


// 通过路由组件额外添加参数信息到表中
interface Props extends RouteComponentProps<{ menu_id: string }> {
    menu_id: string
  }


export const OAMMenuDetail: React.FC<Props> = (props: Props) => {
    const menuId = parseInt(props.location.search.split("=")[1])
    const currentMenu = menuList[menuId - 1]
    
      //点击了编辑按钮
  const onEditBtnClick = (event:any) => {
    //message.success('编辑数据' + event.currentTarget.value)
    event.preventDefault()
    window.open('/oam_menu_edit?menu_id=' + menuId)
  }



    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"3"} openKeys={["sub-project"]}  ></OAMSider>
        <div>
            <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:1000,margin:30 ,paddingTop:20}}>
                <Row align="middle"  gutter={16}>
                    <Col flex='auto' style={{textAlign:'right'}}> <Button style={{borderRadius:20, width:100,marginRight:30}} type={'primary'} onClick={onEditBtnClick}>编 辑</Button></Col>
                </Row>
                <div style={{paddingLeft:30,paddingRight:30}}>
                    <MenuPreview init_menu={currentMenu} />
                </div>
            </Content>
        </div>
    </Layout>
    )

}

export default OAMMenuDetail

